export default "__VITE_ASSET__f22eb005__"